<div class="sidebar h-100" [ngClass]="{ collapsed: isCollapsed }" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <div class="offcanvas-md offcanvas-start h-100" tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
    <div class="offcanvas-header">
      <div class="bg-primary py-3 px-3 d-flex align-items-center justify-content-between w-100" id="sidebarMenuLabel">
        <img class="sidebar-logo d-none d-md-block" src="https://static.truckit.net/t4b/logos/logo-light.svg" alt="image" *ngIf="!isCollapsed" style="max-height: 30px" />
        <img class="sidebar-logo d-none d-md-block" src="https://static.truckit.net/t4b/logos/logo-icon.svg" alt="icon" *ngIf="isCollapsed" style="max-height: 30px" />
        <button type="button" class="btn-close btn-close-white d-md-none ms-auto" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
      </div>
    </div>

    <div class="offcanvas-body h-100 d-flex flex-column mt-3">
      <div class="sidebar-dynamic flex-grow-1 overflow-auto">
        <!-- Skeleton on cold load -->
        <ul *ngIf="menuStatus === 'loading' && menuOptions.length === 0" class="nav flex-column sidebar-content" aria-hidden="true">
          <li *ngFor="let row of skeletonRows" class="nav-item">
            <div class="sidebar-item skeleton-row">
              <span class="sidebar-item-icon">
                <span class="skeleton-icon skeleton-block"></span>
              </span>
              <span class="skeleton-label skeleton-block"></span>
            </div>
          </li>
        </ul>

        <!-- Error state (no cached fallback) -->
        <div *ngIf="menuStatus === 'error' && menuOptions.length === 0" class="sidebar-error">
          <span class="sidebar-error-text">Couldn't load menu</span>
          <button type="button" class="sidebar-retry-btn" (click)="retryLoadMenu()">Retry</button>
        </div>

        <!-- Menu items (stays visible while revalidating) -->
        <ul *ngIf="menuOptions.length > 0" class="nav flex-column sidebar-content">
          <ng-container *ngTemplateOutlet="menuItems; context: { items: menuOptions, offset: 0 }"></ng-container>
        </ul>

        <!-- Shared by the top and bottom groups; `i` is the group's offset + position. -->
        <ng-template #menuItems let-items="items" let-offset="offset">
          <ng-container *ngFor="let item of items; let j = index; trackBy: trackByMenuId">
            <ng-container *ngTemplateOutlet="menuItem; context: { m: item, i: offset + j }"></ng-container>
          </ng-container>
        </ng-template>

        <ng-template #menuItem let-m="m" let-i="i">
          <li
            class="nav-item sidebar-hover"
            [ngClass]="{ 'flyout-parent': isCollapsed && m.children?.length > 0 }"
            (mouseenter)="isCollapsed ? onMenuItemEnter(i, $event) : onSubmenuHover(i, true)"
            (mouseleave)="isCollapsed ? onMenuItemLeave(i) : onSubmenuHover(i, false)"
          >
            <!-- Menu Item Row -->
            <div class="d-flex justify-content-between align-items-center w-100">
              <a
                *ngIf="m.parent_id == 0 || m.parent_id == null"
                class="sidebar-item text-decoration-none flex-grow-1"
                [ngClass]="{ active: isItemActive(m) || isChildActive(m) }"
                (click)="m.children && m.children.length === 0 ? navigateToItem(m) : onParentClick(i)"
                role="button"
              >
                <span class="sidebar-item-icon">
                  <img *ngIf="m.icon?.includes('http')" [src]="m.icon" alt="" />
                  <i *ngIf="!m.icon?.includes('http')" [class]="m.icon"></i>
                </span>
                <span class="sidebar-item-title">{{ m.name }}</span>

                <span class="sidebar-hover-label" *ngIf="isCollapsed && m.children?.length === 0" [style.top.px]="labelTops[i]">
                  {{ m.name }}
                </span>

                <span *ngIf="m.children && m.children.length > 0" class="submenu-indicator ms-auto">
                  <i
                    [ngClass]="{
                      'bi bi-chevron-right': !(isSubmenuVisible(i) || isChildActive(m)),
                      'bi bi-chevron-down': isSubmenuVisible(i) || isChildActive(m),
                    }"
                  ></i>
                </span>
              </a>
            </div>

            <div
              *ngIf="isCollapsed && m.children?.length > 0 && flyoutVisibility[i]"
              class="flyout-submenu"
              [style.top.px]="flyoutTops[i]"
              (mouseenter)="onFlyoutEnter(i)"
              (mouseleave)="onFlyoutLeave(i)"
            >
              <div class="flyout-menu">
                <div class="flyout-header">{{ m.name }}</div>
                <div class="nav flex-column">
                  <div *ngFor="let child of m.children; trackBy: trackByMenuId" class="nav-item">
                    <a class="sidebar-item text-decoration-none" [ngClass]="{ active: isItemActive(child) }" (click)="navigateToItem(child)" role="button">
                      <span class="sidebar-item-icon">
                        <img *ngIf="child.icon?.includes('http')" [src]="child.icon" alt="" />
                        <i *ngIf="!child.icon?.includes('http')" [class]="child.icon"></i>
                      </span>
                      <span class="sidebar-item-title">{{ child.name }}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <ul *ngIf="m.children?.length > 0" [ngClass]="{ submenu: true, 'submenu-visible': isSubmenuVisible(i) || isChildActive(m) }" class="nav flex-column ms-4 submenu">
              <li *ngFor="let child of m.children; trackBy: trackByMenuId" class="nav-item">
                <a class="sidebar-item text-decoration-none" [ngClass]="{ active: isItemActive(child) }" (click)="navigateToItem(child)" role="button">
                  <span class="sidebar-item-icon">
                    <img *ngIf="child.icon?.includes('http')" [src]="child.icon" alt="" />
                    <i *ngIf="!child.icon?.includes('http')" [class]="child.icon"></i>
                  </span>
                  <span class="sidebar-item-title">{{ child.name }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ng-template>

        <!-- Inside the scroll area so it moves with the top group when a parent opens. -->
        <div class="sidebar-static mb-5">
          <ul class="nav flex-column sidebar-content">
            <li class="nav-item" *ngIf="showSwitchOption" (mouseenter)="isCollapsed ? onMenuItemEnter(999, $event) : null" (mouseleave)="isCollapsed ? onMenuItemLeave(999) : null">
              <div class="d-flex justify-content-between align-items-center w-100">
                <button class="sidebar-item text-decoration-none flex-grow-1 text-start bg-transparent border-0 sidebar-hover" (click)="switchMode()" container="body" placement="right">
                  <span class="sidebar-item-icon">
                    <i class="bi bi-arrow-left-right"></i>
                  </span>
                  <span class="sidebar-item-title">Switch to {{ activeMode === 'customer' ? 'Provider' : 'Customer' }}</span>
                  <span class="sidebar-hover-label" *ngIf="isCollapsed" [style.top.px]="labelTops[999]">Switch to {{ activeMode === 'customer' ? 'Provider' : 'Customer' }}</span>
                </button>
              </div>
            </li>

            <ng-container *ngTemplateOutlet="menuItems; context: { items: bottomMenuOptions, offset: bottomOffset }"></ng-container>

            <li class="nav-item" (mouseenter)="isCollapsed ? onMenuItemEnter(1002, $event) : null" (mouseleave)="isCollapsed ? onMenuItemLeave(1002) : null">
              <div class="d-flex justify-content-between align-items-center w-100">
                <a [ngClass]="{ active: isRouteActive(_logoutURL) }" [href]="_logoutURL" class="sidebar-item text-decoration-none flex-grow-1 sidebar-hover">
                  <span class="sidebar-item-icon">
                    <i class="bi bi-box-arrow-right"></i>
                  </span>
                  <span class="sidebar-item-title">Logout</span>
                  <span class="sidebar-hover-label" *ngIf="isCollapsed" [style.top.px]="labelTops[1002]">Logout</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
